var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-snackbar',{attrs:{"multi-line":true,"timeout":_vm.snackbarType == 'Informational' ? 10000 : 5000},model:{value:(_vm.showSnackbar),callback:function ($$v) {_vm.showSnackbar=$$v},expression:"showSnackbar"}},[_vm._v(" "+_vm._s(_vm.snackbarMessage)+" "),_c('v-btn',{attrs:{"text":"","color":_vm.snackbarType == 'Error'
        ? 'red'
        : _vm.snackbarType == 'Success'
        ? 'green'
        : ''},on:{"click":function($event){_vm.showSnackbar = false}}},[_vm._v(" Close ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }